<template>
  <div class="ota-container">
    <el-tabs v-model="activeTab" class="ota-tabs">
      <el-tab-pane :label="$str.getKey('设备升级/标签')" name="tags"></el-tab-pane>
      <el-tab-pane :label="$str.getKey('设备升级/固件包')" name="pkg"></el-tab-pane>
      <el-tab-pane :label="$str.getKey('设备升级/升级')" name="upgrade"></el-tab-pane>
      <el-tab-pane :label="$str.getKey('设备升级/版本信息')" name="versions"></el-tab-pane>
    </el-tabs>

    <div class="ota-content">
      <component :is="currentComponent" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import useAppStore from '@/store/modules/app'
import Tags from './device-upgrade/tags.vue'
import Pkg from './device-upgrade/pkg.vue'
import Upgrade from './device-upgrade/upgrade.vue'
import Versions from './device-upgrade/versions.vue'

const $str = window.$str
const activeTab = ref('tags')
const appStore = useAppStore()

// 四个子 tab 的电站下拉都依赖 appStore.stations，而该数据仅由 layout 在挂载时
// fire-and-forget 拉取一次。首次登录后直接进入本页、或那次请求失败时，
// OTA 子树内没有任何地方会重试，导致选电站/选文件/标签/版本信息全部为空。
// 这里补一道守卫（与 alarm-analysis 中的做法一致），放在 tab 壳上，四个子 tab 共同受益。
onMounted(() => {
  if (!appStore.stations.length) appStore.getStations()
})

const map = {
  tags: Tags,
  pkg: Pkg,
  upgrade: Upgrade,
  versions: Versions,
}

const currentComponent = computed(() => map[activeTab.value])
</script>

<style scoped lang="scss">
.ota-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
}

.ota-tabs {
  flex-shrink: 0;
}

.ota-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
</style>
